import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon, SettingsIcon, LeafIcon } from 'lucide-react';
export function JealousTrustBar() {
  const items = [{
    icon: ShieldCheckIcon,
    text: 'Fully Insured'
  }, {
    icon: CheckCircleIcon,
    text: 'Guaranteed Results'
  }, {
    icon: SettingsIcon,
    text: 'Commercial-Grade Equipment'
  }, {
    icon: LeafIcon,
    text: 'Eco-Friendly Products'
  }];
  return <div className="w-full py-6 px-4 bg-white" style={{
    borderTop: '1px solid rgba(0,0,0,0.05)',
    borderBottom: '1px solid rgba(0,0,0,0.05)'
  }} data-id="element-367">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 place-items-center" data-id="element-368">
        {items.map((item, i) => {
        const Icon = item.icon;
        return <div key={i} className="flex items-center gap-2" data-id="element-369">
              <Icon className="w-5 h-5 flex-shrink-0" style={{
            color: '#3B8AC4'
          }} data-id="element-370" />
              <span style={{
            color: '#4F5B69',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '13px',
            fontWeight: 600
          }} data-id="element-371">
                {item.text}
              </span>
            </div>;
      })}
      </div>
    </div>;
}